import axios from "axios";
import { API } from "@/lib/api";

export const customerApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: "lf_customer_csrf",
  xsrfHeaderName: "X-CSRF-Token",
});
